import React from 'react'
import { AppBar, makeStyles } from '@material-ui/core'
import SafeLogo from '../../../assets/img/SAFE-logo.png'

export const Header = (): JSX.Element => {
  const classes = useStyles()

  return (
    <AppBar className={classes.appbar}>
      <a href="https://www.safecu.org">
        <img className={classes.logo} alt="safe logo" src={SafeLogo} />
      </a>
    </AppBar>
  )
}

const useStyles = makeStyles({
  appbar: {
    position: 'absolute',
    dispay: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 100
  },
  logo: {
    width: 170,
    cursor: 'pointer'
  }
})
